import React from 'react'
import PageHeader from '../../components/pageHeader/PageHeader'

const Privacy = () => {
  return (
    <div>
      <PageHeader title={'Privacy policy'}/>
      <h1>Privacy policy</h1>
    </div>
  )
}

export default Privacy